import styled, { css } from 'styled-components';

import { Wrap as BaseWrap } from '../styled';

import { StyledButton, StyledNavLink } from '@components/Buttons/Button/styled';
import { ViewModeQueries } from '@helpers/viewModeHelper';

interface Props {
  visible?: boolean;
}

const InvalidCredentialsBox = styled.div<Props>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  border: 2px solid #e44448;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin: ${(props) => props.theme.spaces.s20} auto;
  width: 100%;
  max-width: 462px;
  padding: 10px 0;

  ${ViewModeQueries.LG} {
    width: 572px;
    max-width: 572px;
  }

  ${(props) =>
    props.visible !== undefined &&
    css`
      display: ${props.visible === true ? 'flex' : 'none'};
    `};
`;

const ImageSide = styled.div`
  flex: 0 1 auto;
  width: 15%;
  text-align: center;
  align-self: center;

  img {
    max-width: 100%;
    height: auto;
  }
`;

const TextSide = styled.div`
  flex: 0 1 auto;
  width: 85%;

  .title {
    color: ${(props) => props.theme.colors.danger};
    font-size: ${(props) => props.theme.fonts.h3.fontSize};
    line-height: ${(props) => props.theme.fonts.h3.lineHeight_md};
    font-weight: ${(props) => props.theme.fonts.h3.fontWeight};
  }

  .description {
    font-size: ${(props) => props.theme.fonts.h4.fontSize};
    line-height: ${(props) => props.theme.fonts.h4.lineHeight};
    margin-right: 15px;
  }
`;

const Wrap = styled(BaseWrap)`
  padding: 40px 20px;
  ${StyledNavLink} {
    margin-top: ${(props) => props.theme.spaces.s20};
  }
`;

const LinksGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${(props) => props.theme.spaces.s8} 0 ${(props) => props.theme.spaces.s20} 0;

  ${StyledButton} {
    margin-top: 0;
  }
`;
const BtnGoogle = styled.a`
  position: relative;
  display: block;
  width: 100%;
  border-radius: 4px;
  height: 46px;
  font-size: 16px;
  line-height: 46px;
  color: #333;
  text-align: center;
  text-decoration: none;
  padding: 0 16px;
  border: 1px solid rgb(224, 224, 224);
  &:hover {
    color: black;
    border: 1px solid #999;
  }
  svg {
    position: absolute;
    left: 16px;
    top: 12px;
    width: 20px;
    height: 20px;
  }
`;
const DividerWithText = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  color: #999;
  font-size: 16px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #999;
  }

  span {
    margin: 0 16px;
  }
`;

export { InvalidCredentialsBox, ImageSide, TextSide, Wrap, LinksGroup, BtnGoogle, DividerWithText };
